var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDialogMovePoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77.5,
    cy: 75.5,
    r: 70,
    stroke: "#89F3B8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77.5,
    cy: 75.5,
    r: 75,
    stroke: "#89F3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#89F3B8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 75.5C18 42.6391 44.6391 16 77.5 16C110.361 16 137 42.6391 137 75.5C137 108.361 110.361 135 77.5 135C44.6391 135 18 108.361 18 75.5Z",
    fill: "url(#paint0_linear_9568_241047)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8438 61.7656L56.875 48.875L68.9062 61.7656V66.0625H60.3125V93.5625H74.0625V55.75V52.3125H77.5H98.125H101.562V55.75V86.6875H110.156V90.9844L98.125 103.875L86.0938 90.9844V86.6875H94.6875V59.1875H80.9375V97V100.438H77.5H56.875H53.4375V97V66.0625H44.8438V61.7656Z",
    fill: "url(#paint1_linear_9568_241047)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9568_241047",
    x1: 77.5,
    y1: 16,
    x2: 77.5,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9568_241047",
    x1: 65.7946,
    y1: 45.5625,
    x2: 65.7946,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260076,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3FFD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogMovePoint);
export default __webpack_public_path__ + "static/media/img_dialog_move_point.64054965ba1525096c5314d299aaee32.svg";
export { ForwardRef as ReactComponent };